export default __webpack_public_path__ + "static/media/featuredRace2x.7a28ab69.png";